import React from 'react';
import { cn } from '../../poker-ui/utils/cn';
import { BelotSeatFloatingBadge } from './belotSeatFloatingBadge';

/**
 * Универсальная оболочка пузырька FX (торги / речь бела).
 * Для `variant="speech"` передайте `speechTonePair` — тот же стиль, что у капли торгов (`BelotSeatFloatingBadge`).
 */
export function BelotFxBubble({
  variant,
  tail = 'down',
  tailToneClass,
  zIndex,
  className,
  speechTonePair = null,
  children,
}) {
  const isSpeech = variant === 'speech';

  if (isSpeech && speechTonePair) {
    return (
      <div
        className={cn(
          'pointer-events-none relative flex w-max max-w-[min(100%,8.5rem)] sm:max-w-[min(100%,9rem)] flex-col items-center',
          className,
        )}
        style={zIndex != null ? { zIndex } : undefined}
        aria-hidden
      >
        <BelotSeatFloatingBadge bubbleToneClass={speechTonePair.bubble} tailToneClass={speechTonePair.tail}>
          {children}
        </BelotSeatFloatingBadge>
      </div>
    );
  }

  const tipDown =
    tail === 'down' ? tailToneClass || (isSpeech ? 'border-t-amber-100' : 'border-t-white') : '';
  const tipUp =
    tail === 'up' ? tailToneClass || (isSpeech ? 'border-b-amber-50' : 'border-b-white') : '';

  return (
    <div
      className={cn(
        'pointer-events-none relative flex w-max max-w-[7rem] flex-col items-center',
        className,
      )}
      style={zIndex != null ? { zIndex } : undefined}
      aria-hidden
    >
      {isSpeech ? (
        <div className="rounded-[20px] border border-amber-100/40 bg-gradient-to-b from-amber-50 to-amber-100/95 px-3 py-2 shadow-[0_4px_18px_rgba(0,0,0,0.2)]">
          {children}
        </div>
      ) : (
        children
      )}
      {tail !== 'none' && tail === 'down' ? (
        <div
          className={cn(
            'mt-[-1px] h-0 w-0 border-l-[6px] border-r-[6px] border-t-[7px] border-l-transparent border-r-transparent',
            tipDown,
            isSpeech && 'drop-shadow-[0_1px_0_rgba(0,0,0,0.06)]',
          )}
        />
      ) : null}
      {tail !== 'none' && tail === 'up' ? (
        <div
          className={cn(
            'order-first mb-[-1px] h-0 w-0 border-b-[7px] border-l-[6px] border-r-[6px] border-l-transparent border-r-transparent',
            tipUp,
            isSpeech && 'drop-shadow-[0_-1px_0_rgba(0,0,0,0.06)]',
          )}
        />
      ) : null}
    </div>
  );
}
